import React from "react";

import {
  ShowDetailsContainer,
  TitleContainer,
  ShowNameTypography,
} from "./ShowDetails.styles";
import { ShowAudiencePageInterface } from "../../models/Show";


export interface CustomShowDetailsProps {
  show?: ShowAudiencePageInterface | null;
}

export const ShowDetails = ({
  show = null,
  ...rest
}: CustomShowDetailsProps) => {

  return (
    <ShowDetailsContainer>
      <TitleContainer>
        <ShowNameTypography data-cy="ShowDetails-showName">{show?.name}</ShowNameTypography>
      </TitleContainer>
    </ShowDetailsContainer>
  );
};

export interface ShowDetailsProps
  extends React.ComponentProps<typeof ShowDetails> {
  as?: React.ElementType;
}

ShowDetails.displayName = "ShowDetails";
